import {
  getTopic,
  getTopicDropdownOpen
} from 'actions/communication/feedback/feedbackSelectors';
import {
  selectTopic,
  toggleTopicDropdown
} from 'actions/communication/feedback/feedbackActions';
import SubjectDropdownComponent from './SubjectDropdownComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  selectedTopic: getTopic(state),
  topicDropdownOpen: getTopicDropdownOpen(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleTopicDropdown: toggleTopicDropdown,
      selectTopic
    },
    dispatch
  );

// Create higher-order component which feeds in specified props.
const SubjectDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubjectDropdownComponent);

export default SubjectDropdownContainer;



// WEBPACK FOOTER //
// ./src/components/pages/Feedback/SubjectDropdown/SubjectDropdownContainer.js